<template>
  <div class="popularity-table">
    <div class="popularity-table__thead">
      <div class="popularity-table__th">項目</div>
      <div class="popularity-table__th">粉絲</div>
      <div class="popularity-table__th">互動</div>
      <div class="popularity-table__th">貼文</div>
      <div class="popularity-table__th">分享</div>
      <div class="popularity-table__th">話題</div>
    </div><!---
    --><div class="popularity-table__tr popularity-table__candidate">
      <div class="popularity-table__td popularity-table__name">{{ groupData[0].name }}</div>
      <div class="popularity-table__td">
        <div class="popularity-table__td--data">
          {{ groupData[0].fansNum | numeric }}
        </div>
        <SvgSymbol v-if="comparedFans > 0" use="#star" class="popularity-table__star"/>
      </div>
      <div class="popularity-table__td">
        <div class="popularity-table__td--data">
          {{ groupData[0].engagementNum | numeric }}
        </div>
        <SvgSymbol v-if="comparedEngagement > 0" use="#star" class="popularity-table__star"/>
      </div>
      <div class="popularity-table__td">
        <div class="popularity-table__td--data">
          {{ groupData[0].postsNum | numeric }}篇
        </div>
        <SvgSymbol v-if="comparedPosts > 0" use="#star" class="popularity-table__star"/>
      </div>
      <div class="popularity-table__td">
        <div class="popularity-table__td--data">
          {{ groupData[0].sharedNum | numeric }}
        </div>
        <SvgSymbol v-if="comparedShare > 0" use="#star" class="popularity-table__star"/>
      </div>
      <div class="popularity-table__td">
        <div class="popularity-table__td--data">
          {{ groupData[0].topicsNum | numeric }}篇
        </div>
        <SvgSymbol v-if="comparedTopics > 0" use="#star" class="popularity-table__star"/>
      </div>
    </div><!---
    --><div class="popularity-table__tr popularity-table__candidate">
      <div class="popularity-table__td popularity-table__name">{{ groupData[1].name | numeric }}</div>
      <div class="popularity-table__td">
        <div class="popularity-table__td--data">
          {{ groupData[1].fansNum | numeric }}
        </div>
        <SvgSymbol v-if="-comparedFans > 0" use="#star" class="popularity-table__star"/>
      </div>
      <div class="popularity-table__td">
        <div class="popularity-table__td--data">
          {{ groupData[1].engagementNum | numeric }}
        </div>
        <SvgSymbol v-if="-comparedEngagement > 0" use="#star" class="popularity-table__star"/>
      </div>
      <div class="popularity-table__td">
        <div class="popularity-table__td--data">
          {{ groupData[1].postsNum | numeric }}篇
        </div>
        <SvgSymbol v-if="-comparedPosts > 0" use="#star" class="popularity-table__star"/>
      </div>
      <div class="popularity-table__td">
        <div class="popularity-table__td--data">
          {{ groupData[1].sharedNum | numeric }}
        </div>
        <SvgSymbol v-if="-comparedShare > 0" use="#star" class="popularity-table__star"/>
      </div>
      <div class="popularity-table__td">
        <div class="popularity-table__td--data">
          {{ groupData[1].topicsNum | numeric }}篇
        </div>
        <SvgSymbol v-if="-comparedTopics > 0" use="#star" class="popularity-table__star"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopularityTable',
  props: {
    groupData: { type: Array, default: () => [] }
  },
  computed: {
    isComparable () {
      if (!this.groupData ||
        !this.groupData.length ||
        !this.groupData[0] ||
        !this.groupData[0].comparable ||
        !this.groupData[1] ||
        !this.groupData[1].comparable
      ) {
        return false
      }
      return true
    },
    comparedFans () {
      if (!this.isComparable) {
        return 0
      }
      return this.groupData[0].fansNum - this.groupData[1].fansNum
    },
    comparedEngagement () {
      if (!this.isComparable) {
        return 0
      }
      return this.groupData[0].engagementNum - this.groupData[1].engagementNum
    },
    comparedPosts () {
      if (!this.isComparable) {
        return 0
      }
      return this.groupData[0].postsNum - this.groupData[1].postsNum
    },
    comparedTopics () {
      if (!this.isComparable) {
        return 0
      }
      return this.groupData[0].topicsNum - this.groupData[1].topicsNum
    },
    comparedShare () {
      if (!this.isComparable) {
        return 0
      }
      return this.groupData[0].sharedNum - this.groupData[1].sharedNum
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .popularity-table {
    margin-top: 30px;
    text-align: center;

    &__thead {
      display: inline-block;
      width: 20%;
      font-size: 0.875rem;
      letter-spacing: 0.0875rem;
      border: 1px solid #1a1a1a;
      border-bottom: transparent;
      background-color: #f5d1c7;
    }

    &__th {
      height: 35px;
      line-height: 35px;
      border-bottom: 1px solid #1a1a1a;
    }

    &__tr {
      display: inline-block;
      width: 40%;
      font-size: 0.875rem;
      letter-spacing: 0.0875rem;
      border: 1px solid #1a1a1a;
      border-bottom: transparent;
      border-left: transparent;
      vertical-align: top;
      font-weight: 100;
    }

    &__td {
      position: relative;
      text-align: center;
      height: 35px;
      line-height: 35px;
      border-bottom: 1px solid #1a1a1a;
      white-space: nowrap;
    }

    &__td--data {
      display: inline-block;
    }

    &__name {
      font-weight: bold;
    }

    &__star {
      display: inline-block;
      width: 16px;
      vertical-align: top;

      svg {
        fill: #7e93ce;
      }
    }

    @include rwd($RWD_DESKTOP) {
      &__thead {
        display: block;
        width: 100%;
        font-size: 1rem;
        letter-spacing: 0.1rem;
        border: 1px solid #1a1a1a;
      }

      &__th {
        display: inline-block;
        width: 16.6666%;
        height: 55px;
        line-height: 55px;
        border-bottom: transparent;
        border-right: 1px solid #1a1a1a;
      }

      &__th:last-child {
        border: transparent;
      }

      &__tr {
        display: block;
        width: 100%;
        font-size: 1rem;
        letter-spacing: 0.1rem;
        border: 1px solid #1a1a1a;
        border-top: transparent;
      }

      &__td {
        display: inline-block;
        width: 16.6666%;
        height: 55px;
        line-height: 55px;
        vertical-align: top;
        border-bottom: transparent;
        border-right: 1px solid #1a1a1a;
      }

      &__td:last-child {
        border: transparent;
      }

      &__name {
        font-size: 1.125rem;
        letter-spacing: 0.1125rem;
      }
    }
  }
</style>
